var React = require('react');

function TriangleLess (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"Triangle","fill":"#1EAEF1","points":"50 0 100 100 0 100"}));
}

TriangleLess.defaultProps = {"viewBox":"0 0 100 100","version":"1.1"};

module.exports = TriangleLess;

TriangleLess.default = TriangleLess;
